import React from "react";
import { Modal, Input } from "antd";
import PropTypes from "prop-types";

/**
 * AddCreditModal - Modal for adding new credit wallet
 */
const AddCreditModal = ({
  visible,
  packages,
  packagesLoading,
  selectedPackageId,
  note,
  loading,
  onPackageChange,
  onNoteChange,
  onCancel,
  onSubmit,
}) => {
  // Group packages by type
  const groupedPackages = {};
  packages.forEach((pkg) => {
    const type = pkg.Type || "other";
    if (!groupedPackages[type]) {
      groupedPackages[type] = [];
    }
    groupedPackages[type].push(pkg);
  });

  const selectedPkg = packages.find((p) => p.ID === selectedPackageId);
  const isFormValid = selectedPackageId && note && note.trim() !== "";

  return (
    <Modal
      title="Add New Credit Wallet"
      visible={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      confirmLoading={loading}
      okText="Create"
      okButtonProps={{ disabled: !isFormValid }}
      maskClosable={false}
    >
      {packagesLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}>Loading packages...</div>
      ) : (
        <React.Fragment>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontWeight: "bold" }}>Select Package:</label>
            <select
              style={{ width: "100%", marginTop: 8, padding: 8, fontSize: 14 }}
              value={selectedPackageId || ""}
              onChange={(e) => onPackageChange(parseInt(e.target.value, 10) || null)}
            >
              <option value="">-- Select a Package --</option>
              {Object.entries(groupedPackages).map(([type, pkgs]) => (
                <optgroup key={type} label={type.toUpperCase()}>
                  {pkgs.map((pkg) => (
                    <option key={pkg.ID} value={pkg.ID}>
                      {pkg.Name} : ${pkg.Quantity}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
          {selectedPkg && (
            <div
              style={{
                marginBottom: 16,
                padding: 12,
                background: "#f5f5f5",
                borderRadius: 4,
              }}
            >
              <strong>Package Details:</strong>
              <div>Type: {selectedPkg.Type}</div>
              <div>Country: {selectedPkg.CountryAbbr}</div>
              <div>
                Credit:{" "}
                <strong style={{ color: "#52c41a" }}>{selectedPkg.Quantity}</strong>
              </div>
              <div>Expiry: {selectedPkg.Expire} months</div>
            </div>
          )}
          <div>
            <label style={{ fontWeight: "bold" }}>Note: <span style={{ color: '#ff4d4f' }}>*</span></label>
            <Input.TextArea
              style={{ marginTop: 8 }}
              value={note}
              onChange={(e) => onNoteChange(e.target.value)}
              placeholder="Reason for adding credit..."
              rows={3}
            />
          </div>
        </React.Fragment>
      )}
    </Modal>
  );
};

AddCreditModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  packages: PropTypes.array,
  packagesLoading: PropTypes.bool,
  selectedPackageId: PropTypes.number,
  note: PropTypes.string,
  loading: PropTypes.bool,
  onPackageChange: PropTypes.func.isRequired,
  onNoteChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

AddCreditModal.defaultProps = {
  packages: [],
  packagesLoading: false,
  selectedPackageId: null,
  note: "",
  loading: false,
};

export default AddCreditModal;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/modals/AddCreditModal.js